import * as React from "react";
const SvgFlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 10H20L11 23V14H4L13 1V10Z" }));
export default SvgFlash;
